import { render } from "./LeaveTypeDropdown.vue?vue&type=template&id=1e0133f0&scoped=true"
import script from "./LeaveTypeDropdown.vue?vue&type=script&lang=js"
export * from "./LeaveTypeDropdown.vue?vue&type=script&lang=js"

import "./LeaveTypeDropdown.vue?vue&type=style&index=0&id=1e0133f0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0133f0"]])

export default __exports__